export const LIFE_RING_MODAL_ID = "LifeRingModalId";
export const NEED_TO_TALK_ID = "NeedToTalkId";
export const HELP_TEXT_ID = "HelpTextId";
